import { UseFormRegister } from 'react-hook-form';

import { IContactFormSchema } from '@/src/components/contact-form/useContactForm';
import { IResolvedErrors } from '@/src/utils/collections/errors.mapper';

type IProps = {
  label: string | null;
  register: UseFormRegister<IContactFormSchema>;
  errors: string | null | undefined;
  errorTexts?: IResolvedErrors | null;
};

export const ContactFormMessage = ({
  errorTexts,
  label,
  register,
  errors,
}: IProps) => {
  return (
    <div className={'flex flex-col gap-5'}>
      <label htmlFor="message" className={'text-2xl'}>
        <span className={'text-primary'}>{label}</span> *
      </label>
      <textarea
        id="message"
        className={
          'border-0 border-b border-b-light bg-transparent !outline-none'
        }
        {...register('message', {
          required: errorTexts?.requiredField || 'Required',
          minLength: 1,
        })}
        rows={5}
      />
      {errors && <span className="text-sm text-red-500">{errors}</span>}
    </div>
  );
};
